<template lang="html">
  <div class="user-profile" :class="theClass" @click="click">
    <v-row class="size-4">
      <v-col :xs="12" :sm="12" :md="12" :lg="4" class="border-right">
        <v-avatar
          :name="user.name"
          :about="user.location"
          :image="
            'static/_temp/logos/' +
              (Math.floor(Math.random() * 10) + 1) +
              '.png'
          "
        >
        </v-avatar>
        <v-stars class="my-3" mode="full" :stars="4" />
        <v-stars
          :stars="Math.floor(Math.random() * 5) + 1"
          slot="top-right"
        ></v-stars>
      </v-col>
      <v-col :xs="12" :sm="12" :md="12" :lg="8">
        <v-div class="tab-content">
          <v-content class="tab-pane fade" id="tab-skill" role="tabpanel">
            <v-text
              >Lista de habilidades e a experiência do Vibbrante, setado por ele
              no cadastro do perfil.</v-text
            >
            <v-row>
              <v-col :md="12" v-for="i in 7">
                <v-text class="m-0">Javascript:</v-text>
                <div
                  class="progress mb-3 "
                  style="justify-content: space-between;"
                >
                  <div
                    class="progress-bar"
                    role="progressbar"
                    :style="'width:' + (100 - i * 10) + '%;'"
                    aria-valuenow="25"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  >
                    {{ 100 - i * 10 }}%
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-content>
          <v-content
            class="mb-3 tab-pane fade show active"
            id="tab-about"
            role="tabpanel"
          >
            <v-text>
              Definir q texto é esse........
            </v-text>
          </v-content>
        </v-div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import config from '../../configs/js/config';

import FilterBar from './filter-bar';

export default {
  components: {
    'v-filter-bar': FilterBar,
  },
  props: {
    user: Object,
  },
  methods: {
    click() {
      this.$emit('click');
    },
    goToVibbrant() {},
  },
  computed: {
    theClass() {
      return 'type-' + config.profile.names[this.user.type];
    },
  },
};
</script>

<style lang="scss">
.user-profile {
  .user-row-info {
    .col {
      text-align: center;
      background-color: gray(100);
      div.text {
        font-size: 1.4em;
      }
      small.text {
        line-height: 1em;
        font-size: 0.8em;
        display: block;
      }
    }
  }
  .profile-bg {
    height: 130px;
    background: gray(200);
    margin-bottom: -90px;
  }
  .avatar .avatar-image {
    width: 160px;
  }
  .user-about {
    padding: 1em;
  }
  @each $profile in $profiles {
    &.type-#{$profile} {
      .profile-bg {
        background-color: color($profile);
      }
    }
  }

  @include media-breakpoint-down(md) {
    .button {
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/parts/modules/client-profile.vue